module.exports = __webpack_public_path__ + "media/images/pic/hero/sign-efa83df353d394f393c2746c4ac05de6.webp";